export function numberTier(number) {
    return (Math.log10(Math.abs(number)) / 3) | 0;
}

export function numberScale(number) {
    return Math.pow(10, numberTier(number) * 3);
}

export default (number, digits = 1) => {
    if (!number) {
        return 0;
    }

    const symbols = ['', 'k', 'M', 'B', 'T', 'P', 'E'];

    const tier = numberTier(number);
    if (tier === 0) {
        return number % 1 === 0 ? number : number.toFixed(digits);
    }

    const suffix = symbols[tier];

    const scale = numberScale(number);
    const scaled = number / scale;

    let formattedNumber = scaled.toFixed(digits) + suffix;

    symbols.forEach(symbol => formattedNumber = formattedNumber.replace(`.0${symbol}`, ''));

    return formattedNumber;
}
